import * as React from "react";
import tmpReact from "./Helpers";
import Input from "./FormFields/Input";

function Search(props) {
    const onSearchKeyup = (e) => {
        if (props.onSearchKeyup) {
            props.onSearchKeyup(e, props.search);
        } else {
            onSearchKeyupEnter(e);
        }
    };

    const onSearchChange = (e) => {
        props.setSearch(e.target.value);
    };

    const onSearchKeyupEnter = (e) => {
        if (e.keyCode == 13) {
            props.onSearch(props.search);
        }
    };

    return (
        <div className={tmpReact.printClasses(props.classes.container)}>
            <Input
                value={props.search}
                onChange={onSearchChange}
                input={{
                    type: "text",
                    placeholder: props.placeholder,
                    onKeyUp: onSearchKeyup,
                }}
                classes={{
                    input: props.classes.search,
                }}
                icon_after={props.onSearch ? "fas fa-search" : null}
                icon_after_container={
                    props.onSearch
                        ? {
                              className: "cursor-pointer",
                              onClick: () => {
                                  props.onSearch(props.search);
                              },
                          }
                        : null
                }
            />
        </div>
    );
}

export default Search;
